<template>
    <div class="wastewater">
        <div class="item">
            <img class="img" src="@/assets/newscreen/COD.png" alt="">
            <div class="name">CODcr</div>
            <div class="count">排放值<span :class="['countNumber',isDanger('COD') ? 'dangerCountNumber' : '']">{{
                wushuiObj['COD'].currentValue | save3 }}</span>{{ wushuiObj['COD'].unit }}</div>
            <div class="val">限值:{{ wushuiObj['COD'].limitValue }}</div>
            <div class="line"></div>
        </div>
        <div class="item">
            <img class="img" src="@/assets/newscreen/AD.png" alt="">
            <div class="name">氨氮</div>
            <div class="count">排放值<span :class="['countNumber',isDanger('氨氮') ? 'dangerCountNumber' : '']">{{
                wushuiObj['氨氮'].currentValue | save3 }}</span>{{ wushuiObj['氨氮'].unit }}</div>
            <div class="val">限值:{{ wushuiObj['氨氮'].limitValue }}</div>
            <div class="line"></div>
        </div>
        <div class="item">
            <img class="img" src="@/assets/newscreen/PH.png" alt="">
            <div class="name">PH</div>
            <div class="count">排放值<span :class="['countNumber',isDanger('ph') ? 'dangerCountNumber' : '']">{{
                wushuiObj['ph'].currentValue | save3 }}</span></div>
            <div class="val">限值:{{ wushuiObj['ph'].limitValue.toString().replace('.','-') }}</div>
            <div class="line"></div>
        </div>
        <div class="item">
            <img class="img" src="@/assets/newscreen/LL.png" alt="">
            <div class="name">流量</div>
            <div class="count">排放值<span  class="countNumber">{{
                wushuiObj['流量'].currentValue | save3 }}</span>{{ wushuiObj['流量'].unit }}</div>
            <div class="line"></div>
        </div>
        <!-- <div class="moduleh">进水</div> -->
        <!-- <div class="circle-list" style="margin-bottom: 1rem;">
            <circleTemp class="item">
                <div class="name">CODcr</div>
                <div class="count">{{ wushuiObj['COD'].piValue | save3 }}</div>
                <div class="unit">mg/L</div>
            </circleTemp>
            <circleTemp class="item">
                <div class="name">氨氮</div>
                <div class="count">{{ wushuiObj['氨氮'].piValue | save3 }}</div>
                <div class="unit">mg/L</div>
            </circleTemp>
            <circleTemp class="item">
                <div class="name">PH</div>
                <div class="count">{{ wushuiObj['ph'].piValue | save3 }}</div>
            </circleTemp>
            <circleTemp class="item">
                <div class="name">流量</div>
                <div class="count">{{ 0 | save3 }}</div>
            </circleTemp>
        </div> -->
        <!-- <div class="moduleh">出水</div>
        <div class="circle-list">
            <circleTemp class="item">
                <div class="count">100</div>
                <div class="name">COD</div>
            </circleTemp>
            <circleTemp class="item">
                <div class="count">10</div>
                <div class="name">氨氮</div>
            </circleTemp>
            <circleTemp class="item">
                <div class="count">7.75</div>
                <div class="name">PH</div>
            </circleTemp>
        </div> -->
        <!-- <div class="databar">
            <div class="bar-item">
                <div class="val">排放限值:{{wushuiObj['COD'].limitValue}}mg/L</div>
                <div class="procc">
                    <processCompos :value="wushuiObj['COD'].rate" :type="wushuiObj['COD'].rate < 80 ? 'green':'red'"></processCompos>
                    <span class="rate" :style="{color: wushuiObj['COD'].rate < 80 ? '#C7DD3E' : '#FF0037'}">{{wushuiObj['COD'].rate | save3}}%</span>
                </div>
            </div>
            <div class="bar-item">
                <div class="val">排放限值:{{wushuiObj['氨氮'].limitValue}}mg/L</div>
                <div class="procc">
                    <processCompos :value="wushuiObj['氨氮'].rate" :type="wushuiObj['氨氮'].rate < 80 ? 'green':'red'"></processCompos>
                    <span class="rate" :style="{color: wushuiObj['氨氮'].rate < 80 ? '#C7DD3E' : '#FF0037'}">{{wushuiObj['氨氮'].rate | save3}}%</span>
                </div>
            </div>
            <div class="bar-item">
                <div class="val">限值:6-9</div>
                <div class="procc">
                    <img src="@/assets/pinf.png" style="height: 1.3rem;margin-top: 0.25rem;" alt="">
                </div>
            </div>
            <div class="bar-item">
                <div class="val">排放限值:1000m³/h</div>
                <div class="procc">
                    <processCompos :value="0" :type="0 < 80 ? 'green':'red'"></processCompos>
                    <span class="rate" :style="{color: 0 < 80 ? '#C7DD3E' : '#FF0037'}">{{0 | save3}}%</span>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import circleTemp from './circleTemp.vue';
import processCompos from '../process.vue';

export default {
    components: {
        circleTemp,
        processCompos
    },
    props: ["wushuiList"],
    data() {
        return {

        }
    },
    filters: {
        save3: function (val) {
            if (!isNaN(val)) {
                return parseFloat(val).toFixed(2)
            } else {
                return val;
            }
        }
    },
    computed: {
        wushuiObj() {
            if (this.wushuiList.length) {
              let res = {}
              this.wushuiList.forEach(item=>{
                if(item.remark == "污水出水COD"){
                  res["COD"] = item["污水出水COD"]
                }else if(item.remark == "污水出水氨氮"){
                  res["氨氮"] = item["污水出水氨氮"]
                }else if(item.remark == "污水处理后出水流量"){
                  res["流量"] = item["污水处理后出水流量"]
                }else if(item.remark == "污水出水pH"){
                  res["ph"] = item["污水出水pH"]
                }
              })
              return res
            } else {
                return {
                    "COD": {
                        currentValue: 0,
                        limitValue: 0,
                        rate: 0,
                        unit:"mg/L"
                    },
                    "氨氮": {
                        currentValue: 0,
                        limitValue: 0,
                        rate: 0,
                        unit:"mg/L"
                    },
                    "ph": {
                        currentValue: 0,
                        limitValue: 0,
                        unit:""
                    },
                    "流量":{
                      currentValue:0,
                      limitValue:0,
                      unit:"m³/h"
                    }
                }
            }
        }
    },
    methods:{
        isDanger(type){
          let value = this.wushuiObj[type].currentValue | this.save3
          let limitValue = this.wushuiObj[type].limitValue
          if(limitValue){
            if(type != 'ph'){
              return value > limitValue
            }else{
              let min = limitValue.toString().split(".")[0]
              let max = limitValue.toString().split(".")[1]
              return value < min || value > max
            }
          }
          return false
        }
    }
}
</script>

<style lang="scss" scoped>
.wastewater {
    width: 100%;
    height: 100%;
    padding: 1rem;
    font-size: 1rem;

    background: url(../../../assets/newscreen/bg_fszx.png) no-repeat;
    background-size: 100% 100%;

    display: grid;
    grid-template-rows: repeat(4, 25%);

    .item {
        display: flex;
        align-items: center;
        height: 100%;
        position: relative;
        font-size: 1rem;
        color: #5A7EA9;

        .img {
            // max-width: 15%;
            max-height: 100%;
            transform: translate(-0%,-30%);
        }

        .name {
            padding-left: 1rem;
            color: white;
        }

        .count {
            flex: 1;
            padding-left: 0.5rem;
            text-align-last: left;
            .countNumber{
              margin:0rem 0.5rem;
              color: #fff; 
              font-size: 1.6rem;
              background: linear-gradient(to bottom, #FAFEF6, #1FCFFD);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              font-weight: bold;
            }
            .dangerCountNumber{
              background: linear-gradient(to bottom, #FAFEF6, #C90E17);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }

        }

        .line {
            position: absolute;
            bottom: 20%;
            left: calc(8% + 1.2rem);
            width: 90%;
            height: 0.5px;
            background: #FFFFFF;
            opacity: 0.5;

            &::after {
                content: '';
                position: absolute;
                width: 1rem;
                height: 0.5px;
                background: #FFFFFF;
                left: -1rem;
                transform: rotate(45deg);
                transform-origin: bottom right;
            }
        }
    }



    .moduleh {
        background: url(../../../assets/newscreen/bg_title2.png) no-repeat;
        background-size: 100%;
        text-align: center;
        font-size: 1rem;
        color: #F5FAFF;
        letter-spacing: 0;
        text-shadow: 0 2px 4px #44D7B6;
        font-weight: 600;
        margin-bottom: 1rem;
    }

    .circle-list {
        display: flex;
        width: 100%;

        .item {
            width: 33.333%;

            .count {
                color: #FFFFFF;
                letter-spacing: 0;
                text-shadow: 0 0 20px rgba(10, 146, 255, 0.45);
                font-weight: 900;
                font-size: 1.25rem;
            }

            .unit {
                font-size: 0.75rem;
            }
        }
    }

    .databar {
        display: flex;
        width: 100%;

        .bar-item {
            width: 33.333%;
            background: url(../../../assets/newscreen/fszx_bg2.png) no-repeat;
            background-size: 80% auto;
            background-position: center 1rem;
            padding-bottom: 1rem;

            .val {
                font-size: 0.75rem;
                color: #fff; //2333;
            }

            .procc {
                display: flex;
                align-items: center;
                justify-content: center;

                .rate {
                    font-size: 12px;
                    color: #C7DD3E;
                    margin-left: 0.25rem;
                }
            }
        }
    }
}
</style>